import React from 'react';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import ClearIcon from '@mui/icons-material/Clear';
import customAutocompleteStyle from './customAutocompleteStyle';

interface Option {
  label: string;
  value: any;
}

interface CustomAutocompleteProps {
  maxWidth?: string;
  value: Option | null;
  disabled: boolean;
  onChange: (newValue: Option | null) => void;
  inputValue: string;
  onInputChange: (newInputValue: string) => void;
  options: Option[];
  label: string;
  onShowNoMatchMessage?: (show: boolean) => void;
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({
  value,
  maxWidth,
  disabled,
  onChange,
  inputValue,
  onInputChange,
  options,
  label,
  onShowNoMatchMessage,
}) => {
  return (
    <Autocomplete
      value={value}
      disabled={disabled}
      sx={{ maxWidth, ...customAutocompleteStyle.autocomplete }}
      onChange={(e, newValue) => {
        onChange(newValue);
        onShowNoMatchMessage?.(false);
      }}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => {
        onInputChange(newInputValue);
        const hasMatch = options.some((option) =>
          option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        const showMessage = !hasMatch && newInputValue !== '';
        onShowNoMatchMessage?.(showMessage);
      }}
      options={options}
      getOptionLabel={(option: Option) => option.label}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
        />
      )}
      clearIcon={<ClearIcon />}
      clearOnBlur={false}
      clearOnEscape
      clearText="Borrar"
      noOptionsText={null}
    />
  );
};

export default CustomAutocomplete;